export interface Produto {
  id: number;
  slug: string;
  nome: string;
  categoria: string;
  imagem: string;
  descricao: string;
  ordem: number;
  destaque: boolean;
}

export interface Categoria {
  slug: string;
  nome: string;
}

export const categorias: Categoria[] = [
  { slug: "todos", nome: "Todos" },
  { slug: "utilidades", nome: "Utilidades" },
  { slug: "bolsas-e-acessorios", nome: "Bolsas e acessórios" },
  { slug: "moda-e-esporte", nome: "Moda e esporte" },
  { slug: "casa", nome: "Casa" },
  { slug: "cama-mesa-e-banho", nome: "Cama, mesa e banho" },
];

export const produtos: Produto[] = [
  {
    id: 1,
    slug: "copos-termicos",
    nome: "Copos térmicos",
    categoria: "utilidades",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/a8cbd637-6838-445f-8a11-941a198f7194_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-10_54_54.webp",
    descricao: "",
    ordem: 1,
    destaque: true,
  },
  {
    id: 2,
    slug: "umidificador-de-ar",
    nome: "Umidificador de ar",
    categoria: "utilidades",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/432e4c1b-1a7b-47d3-8557-c078f8613bfb_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-10_57_48.webp",
    descricao: "",
    ordem: 2,
    destaque: false,
  },
  {
    id: 3,
    slug: "mochilas",
    nome: "Mochilas",
    categoria: "bolsas-e-acessorios",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/21e45f99-850b-41d5-9414-9228b92eccbe_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-10_56_55.webp",
    descricao: "",
    ordem: 3,
    destaque: true,
  },
  {
    id: 4,
    slug: "bolsas",
    nome: "Bolsas",
    categoria: "bolsas-e-acessorios",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/491699ba-fbfa-4b4e-b55b-52dea0fbec1c_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-10_58_50.webp",
    descricao: "",
    ordem: 4,
    destaque: true,
  },
  {
    id: 5,
    slug: "carteira",
    nome: "Carteira",
    categoria: "bolsas-e-acessorios",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/65183017-eba7-49ab-8ca3-9a4b77bcc997_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_05_19.webp",
    descricao: "",
    ordem: 5,
    destaque: false,
  },
  {
    id: 6,
    slug: "pochete",
    nome: "Pochete",
    categoria: "bolsas-e-acessorios",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/ebe0b8de-8f69-45c7-a5e0-2a122bcc8583_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_01_21.webp",
    descricao: "",
    ordem: 6,
    destaque: false,
  },
  {
    id: 7,
    slug: "short-masculino-de-compressao",
    nome: "Short masculino de compressão",
    categoria: "moda-e-esporte",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/0b50da39-8759-4a66-8f09-ed9218e165cb_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_06_10.webp",
    descricao: "",
    ordem: 7,
    destaque: true,
  },
  {
    id: 8,
    slug: "conjunto-feminino-poliamida",
    nome: "Conjunto feminino poliamida",
    categoria: "moda-e-esporte",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/a5c9984a-e2f2-4472-909c-f974b54d2361_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_06_46.webp",
    descricao: "",
    ordem: 8,
    destaque: true,
  },
  {
    id: 9,
    slug: "tapete-para-banheiro",
    nome: "Tapete para banheiro",
    categoria: "casa",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/17bde5c8-a6e6-48c4-a4cb-f485c880143d_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_10_18.webp",
    descricao: "",
    ordem: 9,
    destaque: false,
  },
  {
    id: 10,
    slug: "tapete-capacho-bem-vindo",
    nome: "Tapete capacho bem-vindo",
    categoria: "casa",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/a9d8b3dc-bfab-4550-a9e3-b78e7c4ae462_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_12_34.webp",
    descricao: "",
    ordem: 10,
    destaque: false,
  },
  {
    id: 11,
    slug: "tapete-antiderrapante-para-cozinha",
    nome: "Tapete antiderrapante para cozinha",
    categoria: "casa",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/2620c833-36fb-426f-82e9-fb69227c594e_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_14_02.webp",
    descricao: "",
    ordem: 11,
    destaque: false,
  },
  {
    id: 12,
    slug: "capa-impermeavel-de-colchao",
    nome: "Capa impermeável de colchão",
    categoria: "cama-mesa-e-banho",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/8abb51c0-2a57-4455-903e-0f7c3b0ea741_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_15_08.webp",
    descricao: "",
    ordem: 12,
    destaque: false,
  },
  {
    id: 13,
    slug: "colcha-de-cama",
    nome: "Colcha de cama",
    categoria: "cama-mesa-e-banho",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/c0412ea0-cd4a-4db9-af0e-69dbf65d3789_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_16_12.webp",
    descricao: "",
    ordem: 13,
    destaque: true,
  },
  {
    id: 14,
    slug: "toalhas",
    nome: "Toalhas",
    categoria: "cama-mesa-e-banho",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/5ddf15d8-b0a4-44a3-b329-04172da36418_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-11_20_25.webp",
    descricao: "",
    ordem: 14,
    destaque: true,
  },
  {
    id: 15,
    slug: "macacao-com-blusa-de-ziper-dry-fit",
    nome: "Macacão com blusa de zíper dry fit",
    categoria: "moda-e-esporte",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/c7726e6b-dbbb-492f-8fe0-018bf6353b38_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-15_33_00.webp",
    descricao: "",
    ordem: 15,
    destaque: true,
  },
  {
    id: 16,
    slug: "conjunto-fitness-masculino",
    nome: "Conjunto fitness masculino",
    categoria: "moda-e-esporte",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/9041b974-fcc3-4e6a-bf1c-4ef3d06e2b0d_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-15_34_57.webp",
    descricao: "",
    ordem: 16,
    destaque: false,
  },
  {
    id: 17,
    slug: "tapete-macarrao",
    nome: "Tapete macarrão",
    categoria: "casa",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/eafa0d0c-7c52-4e1d-bd11-9b4274760545_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-15_36_24.webp",
    descricao: "",
    ordem: 17,
    destaque: false,
  },
  {
    id: 18,
    slug: "garrafa-termica",
    nome: "Garrafa térmica",
    categoria: "utilidades",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/fcb6735b-d799-4b66-889e-bbb087ac554f_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-15_37_23.webp",
    descricao: "",
    ordem: 18,
    destaque: true,
  },
  {
    id: 19,
    slug: "copo-termico-com-canudo",
    nome: "Copo térmico com canudo",
    categoria: "utilidades",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/262d033b-5eae-4032-8463-e7577185d69c_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-15_38_18.webp",
    descricao: "",
    ordem: 19,
    destaque: false,
  },
  {
    id: 20,
    slug: "copo-termico-infantil",
    nome: "Copo térmico (infantil)",
    categoria: "utilidades",
    imagem:
      "https://storage.helloreaddy.io/project_files/ae8bfc9f-f8da-4f2e-a550-293b8efbd08f/90244f64-663a-4a23-9e3b-9d9a05d93193_compressed_Imagem-do-ChatGPT-1-de-out.-de-2026-15_39_41.webp",
    descricao: "",
    ordem: 20,
    destaque: false,
  },
];